/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelManifestProfile.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/manifest-profile";

export class AutogenModelManifestProfile<RowType extends ModelRow> extends Endpoint<RowType, RowManifestProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowManifestProfile extends ModelRow<RowManifestProfileFields> {
	constructor(values?: Partial<RowManifestProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowManifestProfileFields {
	avail_manifest: string;
	company_id: string;
	id: string;
	man_inbndfltr: string;
	man_inbndtype: string;
	man_outbndfltr: string;
	man_outbndtype: string;
	manifest_days: number;
	mileage_server: string;
	order_days: number;
	order_inbndfltr: string;
	order_inbndtype: string;
	order_outbndfltr: string;
	order_outbndtype: string;
	order_resp_codes: string;
	order_resp_level: number;
	profile_color: string;
	prog_manifest: string;
	revenue_code: string;
	shell_manifest: string;
	truckload: string;
}

